import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getEarningsInformationApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.PAYMENT_GATEWAY.GET_EARNINGS_INFORMATION,
            method: 'get',
            data: data,
        })
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}